/* eslint-disable security/detect-object-injection */
import './Task.style.less'
import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  message,
} from 'antd'
import { getOrderCount, getTasks, massUpdateTask } from './Task.service'
import { useEffect, useMemo, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import { TASK_STATUS } from './Task.constant'
import { get } from 'lodash'
import { orderIdAtom } from '@/screens/Order/jotai/order.jotai'
import { transformMassUpdatePayload } from './Task.transform'
import { useAtom } from 'jotai'
import LoadingSpinner from '@/screens/Order/components/LoadingComponent/LoadingSpinner'
import moment from 'moment'

interface ITask {
  name: string
  tasks: string[]
  task_types: string[]
  selected: any[]
}

const { Option } = Select

function Task({ onChange, onClose }: { onChange: any; onClose: any }) {
  const [form] = Form.useForm()

  const [orderId] = useAtom(orderIdAtom)
  const [submit, setsubmit] = useState(false)
  const [taskStatus, setTaskStatus] = useState({})
  const [taskName, setTaskName] = useState(null)

  const {
    data: tasks,
    isLoading,
    isFetching,
  }: any = useQuery<AxiosResponse<{ data: ITask[] }>, Error>(
    ['tasks', orderId],
    () => getTasks(orderId)
  )

  const massUpdateOption = {
    onSuccess: () => {
      message.success('Your modifications have been saved')
      onClose()
    },
    onError: () => {
      message.error('Can not save')
    },
  }

  const { mutate: orderCountMutation, data } = useMutation((payload: any) =>
    getOrderCount(payload?.taskName, payload?.sectionName, payload?.orderIds)
  )

  const options = useMemo(() => {
    if (!tasks) {
      return []
    }

    return tasks.data.data.sections.map(({ name, tasks }) => ({
      value: name,
      label: name,
      children: tasks.map((subTask) => ({
        value: subTask,
        label: subTask,
      })),
    }))
  }, [tasks])

  const {
    mutate,
    isSuccess,
    isError,
    isLoading: isLoadingFormSubmit,
  } = useMutation(massUpdateTask, massUpdateOption)
  const submitDisable = (): boolean => {
    const formData = form.getFieldsValue()
    return !(
      // formData?.comment?.checked ||
      // formData?.plan?.checked ||
      formData?.status?.value
      // formData?.upload?.checked
    )
  }

  useEffect(() => {
    setsubmit(submitDisable())
    if (data) onChange(data.data?.data ?? 0)
  }, [isSuccess, isError, data, isLoadingFormSubmit])
  const onTaskChange = (e) => {
    if (!e) {
      onChange(0)
      return
    }

    const sectionIndex = tasks.data.data.sections.findIndex(
      (section) => section.name === get(e, '[0]')
    )

    const taskIndex = tasks.data.data.sections[sectionIndex].tasks.findIndex(
      (task) => task === get(e, '[1]')
    )

    const taskType =
      tasks.data.data.sections[sectionIndex].task_types[taskIndex]

    setTaskStatus(get(TASK_STATUS, taskType, {}))

    setTaskName(get(e, '[1]'))

    orderCountMutation({
      taskName: get(e, '[1]'),
      sectionName: get(e, '[0]'),
      orderIds: tasks.data.data.ordersId.length,
    })
  }

  return (
    <Form
      name="task-form"
      layout="vertical"
      form={form}
      onChange={() => {
        setsubmit(submitDisable())
      }}
      onFinish={(payload) => {
        mutate(
          transformMassUpdatePayload({
            ...payload,
            orderId: tasks.data.data.ordersId,
            taskName,
          })
        )
      }}
    >
      <Form.Item
        name="task"
        label="Search by task name and select the task to update:"
        rules={[
          {
            required: true,
            message: 'Task is required',
          },
        ]}
      >
        <Cascader
          options={options}
          placeholder="Select a task"
          onChange={onTaskChange}
          notFoundContent={isFetching || isLoading ? <LoadingSpinner /> : null}
          disabled={isLoadingFormSubmit}
        />
      </Form.Item>
      <Form.Item label="Check the boxes of the fields to update and set up new values:">
        <Row justify="center" align="middle">
          <Col span={8}>
            <div className="label-mass-update">Status</div>
          </Col>
          <Col span={16}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues?.status?.checked !== currentValues?.status?.checked
              }
            >
              {({ getFieldValue }) => (
                <Form.Item name={['status', 'value']}>
                  <Select
                    onChange={() => setsubmit(submitDisable())}
                    disabled={
                      (isLoadingFormSubmit || !getFieldValue(['task'])) ?? false
                    }
                    placeholder="Status"
                  >
                    {Object.keys(taskStatus).map((key) => (
                      <Option key={key} value={taskStatus[key]}>
                        {key}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row align={'middle'}>
          <Col span={8}>
            <div className="label-mass-update">Actual Date</div>
          </Col>
          <Col span={16}>
            <Form.Item name={'actual_date'} valuePropName="checked">
              <DatePicker
                disabled={
                  (isLoadingFormSubmit || !form.getFieldValue(['task'])) ??
                  false
                }
                defaultValue={moment()}
                size="large"
                format={'DD MMM YYYY'}
                allowClear={false}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item style={{ textAlign: 'center' }}>
        <Button
          htmlType="button"
          size="large"
          onClick={() => onClose()}
          disabled={isLoadingFormSubmit}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          style={{ marginLeft: 24 }}
          disabled={isLoadingFormSubmit ? isLoadingFormSubmit : submit}
        >
          Update
        </Button>
      </Form.Item>
    </Form>
  )
}

export default Task
